import type { ReactNode } from 'react';
import { AccountAvatar } from './account-avatar';
import { DashboardBrand } from './dashboard-brand';

// The dashboard's dark page and brand header without its tabs, for screens
// shown in place of the dashboard, like its loading and load-error states. The
// tabs would have nothing to show there.
export function BareDashboardLayout({ children }: { children: ReactNode }) {
	return (
		// `dark` and the creators ink as in DashboardLayout.
		<div className="dark min-h-full bg-creators-ink text-primary [color-scheme:dark]">
			<header className="mx-auto flex h-16 max-w-[1040px] items-center justify-between px-xl lg:h-20 lg:px-10">
				<DashboardBrand />
				<AccountAvatar />
			</header>
			<main className="mx-auto max-w-[560px] px-xl pb-12 pt-md lg:pt-12">
				{children}
			</main>
		</div>
	);
}
